import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByPlace',
  standalone: true
})
export class FilterByPlacePipe implements PipeTransform {
  transform(items: any[], place: string): any {
    let places = place.split(',');
    if (!items || !place) {
      return items;
    }
    return items?.filter(item => places.includes(item.place));
  }

}
